import { apiClient } from 'src/services/api/client';
import type { IMessage } from 'src/services/api/messages/types';

export async function fetchLeadMessages(leadUuid: string): Promise<IMessage[]> {
    const searchParams = new URLSearchParams();
    searchParams.append('lead_uuid', leadUuid);
    const res = await apiClient('api/landlord/messages/from-lead', { searchParams });
    return (await res.json<{ messages: IMessage[] }>()).messages;
}